export default __webpack_public_path__ + "static/media/bulk upload debrief cash .594b6bf0.xlsx";